export function useCanvas() {
  function isNullOrEmpty(canvasPolygonData?: string): boolean {
   return canvasPolygonData === undefined || canvasPolygonData === null || canvasPolygonData === '[]';
  }

  return {
    isNullOrEmpty,
  };
}
